<template>
  <!-- prettier-ignore -->
  <div class="over">
    <!-- Module Container -->
    <div id="disp-peak" class="peak-wrapper noselect">
      <!-- Wrapper Info in Overlay -->
      <div class="infoi" v-show="!this.getLoadingStatus || !this.getIsThereData">
        <h2 v-if="!this.getIsThereData && this.getLoadingStatus">{{$t("message.noDataForSensor")}}...</h2>
        <h2 v-else>{{$t("message.loading")}}</h2>
      </div>

      <!-- Video Tutorial -->
      <transition name="settings">
        <ModalVideoTutorial @close-me="showVideoTutorial = false" v-if="showVideoTutorial" :video="'tiltmeter'" />
      </transition>
      <!-- Displacement e Crackmeter -->
      <div v-if="getSelectedSensor && (getSensorType === 'deck' || getSensorType === 'crackmeter')">
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2 v-if="getSelectedSensor.type === 'deck'">{{$t("message.displacementGraph")}}</h2>
          <h2 v-if="getSelectedSensor.type === 'crackmeter'">{{$t("message.crackGraph")}}</h2>
          <p class="first-block">{{$t("message.dataOfSelectedDevice")}}</p>
        </div>
        <LinePlot v-if="getSelectedSensor && getSensorType === 'deck'" :height="this.plotHeight" :traces="this.getDispTrace" xTitle="Time (Hr)" yTitle="Pk - Pk (mm)" />
        <LinePlot
          v-if="getSelectedSensor && getSensorType === 'crackmeter' && !getSelectedSensor.subType"
          :height="this.plotHeight"
          :traces="this.getCrackTrace"
          xTitle="Time (Hr)"
          :yTitle="$t('dataType.crack') +' (mm)'"
        />
        <LinePlot
          v-if="getSelectedSensor && getSensorType === 'crackmeter' && getSelectedSensor.subType && getSelectedSensor.subType === 'loadcell'"
          :height="this.plotHeight"
          :traces="this.getLoadTrace"
          xTitle="Time (Hr)"
          :yTitle="'Load (N)'"
        />
      </div>
      <!-- Nodo -->
      <div v-if="getSelectedSensor && (getSensorType === 'analog-node' || getSensorType === 'digital-node')">
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2>{{ 'Analog Node' }}</h2>
          <p class="first-block">{{ 'Analog Node Data'}}</p>
        </div>
        <div class="four-plot">
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH1Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[0].name + ' [' + (getSelectedSensor.userConfig.channels[0].mesUnit || ' - ')  + ']'" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH2Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[1].name + ' [' + (getSelectedSensor.userConfig.channels[1].mesUnit || ' - ') + ']'" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH3Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[2].name + ' [' + (getSelectedSensor.userConfig.channels[2].mesUnit || ' - ')  + ']'" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAnNodeCH4Trace" xTitle="Time (Hr)" :yTitle="getSelectedSensor.userConfig.channels[3].name + ' ' + (getSelectedSensor.userConfig.channels[3].mesUnit || ' - ')  + ']'" />
          </div>
        </div>
      </div>
      <!-- Tiltmeter -->
      <div v-if="getSelectedSensor && (getSensorType === 'tiltmeter')">
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2>{{$t("message.tiltGraph")}}</h2>
          <p class="first-block">{{$t("message.dataOfSelectedDevice")}}</p>
          <img class="info-svg" @click="showVideoTutorial = true" src="../../../../public/assets/icons/info.svg" alt />
        </div>
        <div class="double-small-graphs" v-if="true">
          <div class="small-graph">
            <div class="main-wrap over-info" v-if="this.getSelectedSensor"></div>
            <LinePlot
              v-if="getSelectedSensor && getSensorType === 'tiltmeter'"
              :height="this.plotHeight"
              :traces="this.getTiltTraceSub1"
              xTitle="Time (Hr)"
              :yTitle="'Δφ ' + $t('dataType.tilt') + ' ' + (this.mesUnit && this.mesUnit.degrees === 'mm/m' ? '[mm/m]' : '°')"
            />
          </div>
          <div class="small-graph">
            <div class="main-wrap over-info" v-if="this.getSelectedSensor"></div>
            <LinePlot
              v-if="getSelectedSensor && getSensorType === 'tiltmeter'"
              :height="this.plotHeight"
              :traces="this.getTiltTraceSub2"
              xTitle="Time (Hr)"
              :yTitle="'Δϑ ' + $t('dataType.tilt') + ' ' + (this.mesUnit && this.mesUnit.degrees === 'mm/m' ? '[mm/m]' : '°')"
            />
          </div>
        </div>
        <div class="horiz-divider"></div>
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2>{{$t("message.tilt3dGraph")}}</h2>
          <p class="first-block">{{$t("message.dataOfSelectedDevice")}}</p>
        </div>
        <LinePlot
          v-if="getSelectedSensor && getSensorType === 'tiltmeter'"
          :height="this.plotHeight"
          :traces="this.getTiltTrace"
          xTitle="Time (Hr)"
          :yTitle="$t('dataType.tilt') + ' ' + (this.mesUnit && this.mesUnit.degrees === 'mm/m' ? '[mm/m]' : '°')"
        />
      </div>

      <!-- Accelerationi -->
      <div v-if="getSelectedSensor && (getSensorType === 'accelerometer')">
        <div class="main-wrap over-info" v-if="this.getSelectedSensor">
          <h2>{{$t("message.accelerationsGraph")}}</h2>
          <p class="first-block">{{$t("message.dataOfSelectedDevice")}}</p>
        </div>
        <div class="multi-plot">
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAccXTrace" xTitle="Time (Hr)" yTitle="Peak to Peak X (mg)" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAccYTrace" xTitle="Time (Hr)" yTitle="Peak to Peak Y (mg)" />
          </div>
          <div class="single-plot">
            <LinePlot v-if="getSelectedSensor" :height="this.plotHeight" :traces="this.getAccZTrace" xTitle="Time (Hr)" yTitle="Peak to Peak Z (mg)" />
          </div>
        </div>
      </div>
    </div>

    <!-- Grafico delle temperature mostrato se è selezionato un Accelerometro, Inclinometro o Estensimetro -->
    <div id="temp-peak" class="peak-wrapper temp-wrapper noselect" v-if="getSelectedSensor && (getSensorType === 'accelerometer' || getSensorType === 'tiltmeter' || getSensorType === 'crackmeter')">
      <!-- Wrapper Info in Overlay -->
      <div class="infoi" v-show="!this.getLoadingStatus || !this.getIsThereData">
        <h2 v-if="!this.getIsThereData && this.getLoadingStatus">{{$t("message.noDataForSensor")}}...</h2>
        <h2 v-else>{{$t("message.loading")}}...</h2>
      </div>
      <div class="main-wrap over-info" v-if="this.getSelectedSensor">
        <h2>{{$t("message.temperatureGraph")}}</h2>
        <p class="first-block">{{$t("message.dataOfSelectedDevice")}}</p>
      </div>
      <div>
        <LinePlot v-if="getSelectedSensor" :height="this.subPlotHeight" :traces="this.getTemperaturesTrace" xTitle="Time (Hr)" yTitle="Temperature (°C)" />
      </div>
    </div>
  </div>
</template>
<script>
/* 
Modulo che grafica gli eventi delle ultime 24h relative al sensore selezionato.
Attualmente sono previsti "tilt", "displacement" e "acceelrations"
*/

import LinePlot from "../../graphs/LinePlot.vue";
import { mapGetters, mapActions } from "vuex";
import ModalVideoTutorial from "../../ui/ModalVideoTutorial";
import math from "../../../helpers/math.js";
var mql = window.matchMedia("screen and (max-width: 1499px)"); //Media per l'adattamento agli schermi

export default {
  name: "thresholdpeaks-module",
  components: {
    LinePlot,
    ModalVideoTutorial,
  },
  data() {
    return {
      loaded: false,
      firstExec: true,
      plotHeight: 600,
      subPlotHeight: 350,
      showVideoTutorial: false,
      today: new Date(new Date()).toLocaleString().split(",")[0],
      /* Trace di base a cui vengono aggiunti attributi in base al grafico */
      baseTrace: {
        connectgaps: true,
        line: {
          color: "rgb(17, 205, 239)",
          width: 4,
        },
        marker: {
          color: "rgb(255, 255, 255)",
          size: 4,
        },
        name: "Peaks Line",
        type: "scatter",
        xaxis: "x",
        yaxis: "y",
        opacity: 0.9,
        textfont: {},
      },
    };
  },
  methods: {
    ...mapActions("lastevents", ["setDateRange", "fetchDiffPeaks", "setSelectedSensor", "setAbsolute3dAngle"]),
    /* Handler per la reponsiveness dei grafici */
    responsiveScreenHandler(e) {
      if (e.matches) {
        this.plotHeight = 460;
        this.subPlotHeight = 290;
      } else {
        this.plotHeight = 600;
        this.subPlotHeight = 350;
      }
    },
  },
  computed: {
    ...mapGetters("lastevents", [
      "getSensorType",
      "getSelectedSensor",
      "getDateRange",
      "getSensorType",
      "getAccelerations",
      "getVibrations",
      "getTemperatures",
      "getTilts",
      "getAnalogReadings",
      "getCracks",
      "getBaseValue",
      "getRelativeMode",
      "getLoadingStatus",
      "getIsThereData",
    ]),
    ...mapGetters("structure", ["getSensors"]),
    ...mapGetters("user", ["getInterface"]),
    mesUnit() {
      return this.getInterface ? this.getInterface.dimensions : null;
    },
    /* Restituisce un oggetto contente 4 array relativi alle date ed alle accelerazioni rispettive sui 3 assi (converto in mg) */
    getAxixAccelerations: function () {
      return {
        dates: this.getAccelerations.map((a) => new Date(a.date)),
        x: this.getAccelerations.map((a) => (a.acceleration.xPeak * 1000).toFixed(3)),
        y: this.getAccelerations.map((a) => (a.acceleration.yPeak * 1000).toFixed(3)),
        z: this.getAccelerations.map((a) => (a.acceleration.zPeak * 1000).toFixed(3)),
      };
    },
    /* Restituisce la trace relativa alle accelerazione sull'asse X */
    getAccXTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAxixAccelerations.dates;
      basicTrace.y = this.getAxixAccelerations.x;
      return [basicTrace];
    },
    /* Restituisce la trace relativa alle accelerazione sull'asse Y */
    getAccYTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAxixAccelerations.dates;
      basicTrace.y = this.getAxixAccelerations.y;
      return [basicTrace];
    },
    /* Restituisce la trace relativa alle accelerazione sull'asse Z */
    getAccZTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAxixAccelerations.dates;
      basicTrace.y = this.getAxixAccelerations.z;
      return [basicTrace];
    },
    getAnNodeCH1Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAnalogReadings.map((event) => new Date(event.date));
      basicTrace.y = this.getAnalogReadings.map((event) => event.channelsData[0]);
      return [basicTrace];
    },
    getAnNodeCH2Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAnalogReadings.map((event) => new Date(event.date));
      basicTrace.y = this.getAnalogReadings.map((event) => event.channelsData[1]);
      return [basicTrace];
    },
    getAnNodeCH3Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAnalogReadings.map((event) => new Date(event.date));
      basicTrace.y = this.getAnalogReadings.map((event) => event.channelsData[2]);
      return [basicTrace];
    },
    getAnNodeCH4Trace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      basicTrace.x = this.getAnalogReadings.map((event) => new Date(event.date));
      basicTrace.y = this.getAnalogReadings.map((event) => event.channelsData[3]);
      return [basicTrace];
    },
    /* Restituisce la trace relativa ai displacement */
    getDispTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getVibrations) {
        basicTrace.x = this.getVibrations.map((a) => new Date(a.date));
        basicTrace.y = this.getVibrations.map((a) => (a.payload.piccoMax - a.payload.piccoMin).toFixed(2));
      } else {
        basicTrace.x = [];
        basicTrace.y = [];
      }
      return [basicTrace];
    },
    getTiltTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getTilts) {
        //basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        //basicTrace.y = this.getTilts.map((a) => this.mesUnit && this.mesUnit.degrees === 'mm/m' ? math.degreesToMM(a.extraAngle).toFixed(6) : a.extraAngle.tilt.toFixed(6))
        //basicTrace.text = this.getTilts.map((a) => ("Versor: [" + a.extraAngle.versor[0].toFixed(4)).toString() + ', ' + (a.extraAngle.versor[1].toFixed(4)).toString() + ', ' +  (a.extraAngle.versor[2].toFixed(4)).toString() + "]")
        basicTrace.x = this.getTilts.map((a) => new Date(a.date));
        basicTrace.y = this.getTilts.map((a) =>
          this.mesUnit && this.mesUnit.degrees === "mm/m" ? math.degreesToMM(a.extraAngle).toFixed(6) : a.extraAngle.toFixed(6)
        );
      } else {
        basicTrace.x = [];
        basicTrace.y = [];
      }
      return [basicTrace];
    },
    getTiltTraceSub1: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getTilts) {
        //basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        //basicTrace.y = this.getTilts.map((a) => this.mesUnit && this.mesUnit.degrees === 'mm/m' ? math.degreesToMM(a.phiAngle).toFixed(6) : a.phiAngle.toFixed(6))
        basicTrace.x = this.getTilts.map((a) => new Date(a.date));
        basicTrace.y = this.getTilts.map((a) =>
          this.mesUnit && this.mesUnit.degrees === "mm/m" ? math.degreesToMM(a.phiAngle).toFixed(6) : a.phiAngle.toFixed(6)
        );
      } else {
        basicTrace.x = [];
        basicTrace.y = [];
      }
      return [basicTrace];
    },
    getTiltTraceSub2: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getTilts) {
        //basicTrace.x = this.getTilts.map((a) => new Date(a.date))
        //basicTrace.y = this.getTilts.map((a) => this.mesUnit && this.mesUnit.degrees === 'mm/m' ? math.degreesToMM(a.thetaAngle).toFixed(6) : a.thetaAngle.toFixed(6))
        basicTrace.x = this.getTilts.map((a) => new Date(a.date));
        basicTrace.y = this.getTilts.map((a) =>
          this.mesUnit && this.mesUnit.degrees === "mm/m" ? math.degreesToMM(a.thetaAngle).toFixed(6) : a.thetaAngle.toFixed(6)
        );
      } else {
        basicTrace.x = [];
        basicTrace.y = [];
      }
      return [basicTrace];
    },
    getCrackTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getCracks) {
        let offset = this.getRelativeMode && this.getBaseValue ? this.getBaseValue : 0;
        basicTrace.x = this.getCracks.map((a) => new Date(a.date));
        basicTrace.y = this.getCracks.map((a) => a.sample - offset);
      } else {
        basicTrace.x = [];
        basicTrace.y = [];
      }
      return [basicTrace];
    },
    getLoadTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getCracks) {
        basicTrace.x = this.getCracks.map((a) => new Date(a.date));
        basicTrace.y = this.getCracks.map((a) => (a.sample / (3.92 * Math.pow(10, -3)) - 6400) * 11.71875);
      } else {
        basicTrace.x = [];
        basicTrace.y = [];
      }
      return [basicTrace];
    },
    getTemperaturesTrace: function () {
      let basicTrace = JSON.parse(JSON.stringify(this.baseTrace));
      if (this.getTemperatures) {
        basicTrace.x = this.getTemperatures.map((a) => new Date(a.date));
        /* TOGLIEREEEEEEE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TOGLIERE TOGLIERE TOGLIERE TOGLIERE TOGLIERE TOGLIERE */
        basicTrace.y = this.getTemperatures.filter((a) => a.temperature < 31 && !isNaN(a.temperature)).map((a) => a.temperature.toFixed(2));
      }
      return [basicTrace];
    },
  },
  async mounted() {
    // Verifico la dimensione della finestra e aggiungo listener per gestire il ridimensionamento
    this.responsiveScreenHandler(mql);
    mql.addListener(this.responsiveScreenHandler);

    this.setDateRange([
      // Setto il dateRange alle ultime 24h
      new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
      new Date(),
    ]);
    /* this.setSelectedSensor(this.getSensors[0]) */
    if (this.getInterface && this.getInterface.absolute3dAngle === false) {
      this.setAbsolute3dAngle(false);
    }
  },
  watch: {
    getSelectedSensor: {
      handler: async function () {
        // Init and Date already ok
        if (!this.firstExec) {
          this.loaded = false;
          await this.fetchDiffPeaks();
          this.loaded = true;
        }
        this.firstExec = false;
      },
      deep: true,
    },
    getDateRange: {
      handler: async function () {
        // Init and Sensor already ok
        if (!this.firstExec) {
          this.loaded = false;
          await this.fetchDiffPeaks();
          this.loaded = true;
        }
        this.firstExec = false;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
/* Main Wrapper */
.over {
  min-width: 1000px;
  width: 92%;
  column-gap: 2%;
  display: grid;
  grid-template-columns: 49% 49%;
  margin-left: 4%;
  margin-right: 4%;
}

/* Wrapper Evento */
.peak-wrapper {
  position: relative;
  /* height: 700px; */
  margin-top: 30px;
  padding-bottom: 1%;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
}

.double-small-graphs {
  display: grid;
  grid-template-columns: 5fr 5fr;
  column-gap: 40px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  /* border-bottom: solid 2px white; */
}

/* Wrapper Temperature */
.temp-wrapper {
  height: 450px;
}

/* Contenitore grafico singolo */
.single-plot {
  width: 33%;
  grid-template-columns: 100%;
  display: grid;
}

/* Contenitore grafici multipli */
.multi-plot {
  display: flex;
}
.four-plot {
  display: grid;
  grid-template-columns: 5fr 5fr;
  grid-template-rows: 5fr 5fr;
}
.four-plot .single-plot {
  width: 100%;
}

/* ID Evento principale */
#disp-peak {
  width: 100%;
  grid-row: 2;
  grid-column-start: 1;
  grid-column-end: 3;
}

/* ID temperature */
#temp-peak {
  width: 100%;
  grid-row: 3;
  grid-column-start: 1;
  grid-column-end: 3;
}

/* Overlay Info */
.infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-radius: 10px;
  background-color: black;
  z-index: 9;
  opacity: 0.7;
}
.infoi > h2 {
  margin: auto;
}
/* Divisori */
.horiz-divider {
  height: 2px;
  background-color: rgba(80, 84, 105, 1);
  margin: auto;
  margin-top: 60px;
  margin-bottom: 60px;
  width: 90%;
}

/* Info in alto sinistra sul tipo di grafico */
.over-info > h2 {
  font-size: 1em;
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info > p {
  font-size: 0.8em;
  margin-top: 0;
  margin-bottom: 0;
}
.over-info {
  text-align: left;
  position: relative;
  margin-top: 1.5%;
  display: grid;
  margin-left: 60px;
  grid-template-columns: max-content;
}

.info-svg {
  cursor: pointer;
  grid-column: 2;
  grid-row: 1;
  margin-left: -20px;
}

/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .over {
    width: 96%;
    margin-left: 2%;
    margin-right: 2%;
  }
  /*   .peak-wrapper {
         height: 550px;
 
  } */
  .temp-wrapper {
    height: 390px;
  }
}
</style>
